<template>
  <div class="body-wrapper">
    <ObjectsEmpty v-if="noObjects" />

    <EmptyStateGeneric
      v-else
      top
    >
      <div class="mb-2">
        <Icon
          type="arrow-right-circle"
          class="tw-rotate-180 h-auto w-[110px] fill-[url(#svg-brand-gradient)] opacity-40"
        />
      </div>

      <h2 class="margin-bottom-lg text-xl text-emphasis font-medium mb-2">
        Select a Table
      </h2>

      <p class="text-default mb-6">
        Select a table from the left panel to view its tasks
      </p>
    </EmptyStateGeneric>
  </div>
</template>

<script>
import ObjectsEmpty from '@/components/objects/ObjectsEmpty';
import EmptyStateGeneric from '@/components/ui/EmptyStateGeneric';
import Icon from '@/components/ui/Icon';

export default {
  components: {
    ObjectsEmpty,
    Icon,
    EmptyStateGeneric,
  },
  props: [
    'layout',
  ],
  data() {
    return {};
  },
  computed: {
    noObjects() {
      return this.$store.getters.objects.length === 0;
    },
  },
};
</script>
